export default {
  FestivalArea: "FestivalArea",
  addFestivalArea: "AddFestivalArea",
  editFestivalArea: "EditFestivalArea",
};
